<template>
  <div class="tab-pane" id="siteDetails">
    <h3 class="info-text mb-0">Site Details</h3>
    <p class="text-center text-secondary mb-4">
      <em>Site and current host details</em>
    </p>
    <div class="row justify-content-center">
      <div class="col-12 pr-5 pl-5">
        <div
          class="row border-bottom-color-line pb-3"
          v-for="(acc, index) in migrationDomain"
          :key="index"
          :class="{ 'pt-4': index > 0 }"
        >
          <div class="col-12" v-if="index === 0">
            <div class="count-badges center mb-2">
              <span class="badge bg-violate big-badge mr-2"
                >Migrations Used: {{ freeMigrationCountShow }} of
                {{ migrationFreeLimit }}</span>
              <span class="badge bg-teal big-badge"
                >Addon Domains Used: {{ freeAddonCountShow }} of
                {{ addonFreeLimit }}</span>
            </div>
          </div>
          <div class="col-12" v-if="index > 0">
            <button
              type="button"
              class="close text-red"
              aria-label="Close"
              @click.prevent="deleteAccountItem(index, $event)"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label for="migrationDomainName"
                >Domain Name of the Site to Migrate
                <strong class="text-danger">*</strong></label
              >
              <select
                class="form-control form-control-sm domain_selection"
                :name="`migrationDomainName_${index}`"
                v-model="acc.domain"
                required
                style="min-height:3em;"
                @change="fillWPAdminLoginUrl(index)"
              >
                <option value="">Choose your Domain</option>
                <option
                  v-for="(domain, index) in domainList"
                  :disabled="
                    acc.domain !== domain && selectedDomains.includes(domain)
                  "
                  :key="index"
                  :value="domain"
                  >{{ domain }}</option
                >
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <strong
              class="text-danger mr-4 d-inline-block"
              style="vertical-align: sub; font-size: 1.4em;"
              >OR</strong
            >
            <div class="form-group align-baseline d-inline-block">
              <button
                class="btn btn-primary btn-round d-block mt-4"
                data-toggle="modal"
                data-target="#addAddonDomain"
                @click.prevent="fixModal(index)"
              >
                <i class="fa fa-plus"></i> Add New Addon Domain
              </button>
            </div>
          </div>
          <div class="col-12" v-if="index > 0">
            <div class="form-group mt-2">
              <div
                class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate"
                :class="{
                  'bootstrap-switch-on bootstrap-switch-focused':
                    acc.hostSameAsAbove,
                  'bootstrap-switch-off bootstrap-switch-focused': !acc.hostSameAsAbove,
                }"
              >
                <div
                  class="bootstrap-switch-container"
                  @click="hostSameAsAbove(index)"
                >
                  <span
                    class="bootstrap-switch-handle-on bootstrap-switch-primary"
                    >Yes</span
                  >
                  <span class="bootstrap-switch-label"></span>
                  <span
                    class="bootstrap-switch-handle-off bootstrap-switch-default"
                    >No</span
                  >
                </div>
              </div>
              <label
                for="hostSameAsAbove"
                class="ml-2"
                style="font-size: 14px;"
              >
                Are the old hosting details the same as
                {{ migrationDomain[0].domain }}?
              </label>
            </div>
          </div>
          <div class="col-12" v-if="!acc.hostSameAsAbove && index === 0">
            <p>
              <span class="badge badge-info mb-0">Please Note</span>
              Enter the URL and login details to your hosting panel below. Your
              hosting panel is where you currently log-in to manage your domains
              and other hosting services. Ideally this would be either your
              host’s billing and support login or cPanel/WHM.
            </p>
          </div>
          <div v-if="acc.accessGranted" class="col-md-12 ">
            <button
              class="btn btn-default btn-round btn-sm d-block pull-right"
              @click="resetHostFields(index)"
            >
              Reset Host Fields
            </button>
          </div>
          <div class="col-sm-12 col-md-6" v-if="!acc.hostSameAsAbove">
            <div class="form-group">
              <label for="currentHost"
                >Name of Current Host
                <strong class="text-danger">*</strong></label
              >
              <select
                class="form-control"
                :name="`currentHost_${index}`"
                v-model.trim="acc.currentHost.name"
                @change="changedHost(acc.currentHost.name, index)"
                required
                style="padding-bottom: 5px"
              >
                <option v-for="host in commonHosts" :value="host" :key="host">{{
                  host
                }}</option>
              </select>
              <!--							<input type="text" class="form-control" :name="`currentHost_${index}`" v-model.trim="acc.currentHost.name" required placeholder="Example: WP Engine">-->
            </div>
          </div>
          <div class="col-sm-12 col-md-6" v-if="acc.showAccessBtn">
            <button
              class="btn btn-primary btn-round d-block mt-4"
              data-toggle="modal"
              data-target="#site-access-video"
              @click.prevent="fixModal(index)"
            >
              Give BigScoots Access
            </button>
          </div>
          <div
            class="col-sm-12 col-md-6"
            v-if="!acc.hostSameAsAbove && !acc.showAccessBtn"
          >
            <div class="form-group">
              <label for="currentHostURL"
                >Hosting Panel Login Web Address (URL)
                <strong class="text-danger">*</strong></label
              >
              <input
                type="text"
                class="form-control"
                :disabled="acc.currentHost.url === 'Access granted'"
                :name="`currentHostURL_${index}`"
                placeholder="Example: https://domain.com/cpanel"
                required
                v-model.trim="acc.currentHost.url"
              />
            </div>
          </div>
          <div
            class="col-sm-12 col-md-6"
            v-if="!acc.hostSameAsAbove && !acc.showAccessBtn"
          >
            <div class="form-group">
              <label for="currentHostUsername"
                >Hosting Panel Username
                <strong class="text-danger">*</strong></label
              >
              <input
                type="text"
                class="form-control"
                :disabled="acc.currentHost.username === 'Access granted'"
                :name="`currentHostUsername_${index}`"
                required
                v-model.trim="acc.currentHost.username"
              />
            </div>
          </div>
          <div
            class="col-sm-12 col-md-6"
            v-if="!acc.hostSameAsAbove && !acc.showAccessBtn"
          >
            <div class="form-group">
              <label for="currentHostPassword"
                >Hosting Panel Password
                <strong class="text-danger">*</strong></label
              >
              <input
                type="text"
                class="form-control"
                :disabled="acc.currentHost.password === 'Access granted'"
                :name="`currentHostPassword_${index}`"
                required
                v-model.trim="acc.currentHost.password"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label :for="'wp-username' + index"
                >WordPress Admin Username
                <strong class="text-danger">*</strong></label
              >
              <input
                v-model.trim="acc.wpAdminDetails.username"
                type="text"
                :id="'wp-username' + index"
                :name="'wp-username' + index"
                class="form-control"
                required
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label :for="'wp-password' + index"
                >WordPress Admin Password
                <strong class="text-danger">*</strong></label
              >
              <input
                v-model.trim="acc.wpAdminDetails.password"
                type="text"
                :id="'wp-password' + index"
                :name="'wp-password' + index"
                class="form-control"
                required
              />
            </div>
          </div>
          <div class="col-12">
            <p>
              <span class="badge badge-info mb-0">Please Note</span>
              This can be your WordPress admin login or you may create a new
              WordPress admin login for us.
              <a
                target="_blank"
                href="https://help.bigscoots.com/en/articles/1623228-how-to-create-a-new-wordpress-admin-user"
                >How to create a new WordPress admin user?</a
              >
            </p>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label :for="'wp-admin-url' + index"
                >WordPress Login URL<strong class="text-danger"
                  >*</strong
                ></label
              >
              <input
                v-model.trim="acc.wpAdminDetails.loginURL"
                type="text"
                :id="'wp-admin-url' + index"
                :name="'wp-admin-url' + index"
                class="form-control"
                required
              />
            </div>
          </div>
          <div class="col-12">
            <p>
              <span class="badge badge-info mb-0">Please Note</span>
              This is the default WordPress admin URL, but yours may differ.
            </p>
          </div>
          <div class="col-12" v-if="!acc.hostSameAsAbove">
            <div class="form-group mt-2">
              <div
                class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate"
                :class="{
                  'bootstrap-switch-on bootstrap-switch-focused': acc.haveSSH,
                  'bootstrap-switch-off bootstrap-switch-focused': !acc.haveSSH,
                }"
              >
                <div
                  class="bootstrap-switch-container"
                  @click="acc.haveSSH = !acc.haveSSH"
                >
                  <span
                    class="bootstrap-switch-handle-on bootstrap-switch-primary"
                    >Yes</span
                  >
                  <span class="bootstrap-switch-label"></span>
                  <span
                    class="bootstrap-switch-handle-off bootstrap-switch-default"
                    >No</span
                  >
                </div>
              </div>
              <label for="haveSSH" class="ml-2" style="font-size: 14px;">
                Do you have SSH details for this site?
                <i
                  class="fa fa-question-circle ml-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="If you do not have SSH details available for this site, do not worry! Please continue."
                ></i>
              </label>
            </div>
          </div>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            mode="in-out"
          >
            <div
              class="col-sm-12 col-md-6"
              v-if="acc.haveSSH && !acc.hostSameAsAbove"
            >
              <div class="form-group">
                <label for="sshIP">Server IP Address</label>
                <input
                  type="text"
                  pattern="((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$"
                  :name="`sshIP_${index}`"
                  class="form-control"
                  placeholder="Example: 80.230.133.217"
                  required
                  v-model.trim="acc.ssh.ip"
                />
              </div>
            </div>
          </transition>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            mode="in-out"
          >
            <div
              class="col-sm-12 col-md-6"
              v-if="acc.haveSSH && !acc.hostSameAsAbove"
            >
              <div class="form-group">
                <label for="sshIP">Port</label>
                <input
                  type="number"
                  :name="`sshPort_${index}`"
                  class="form-control"
                  required
                  v-model.trim="acc.ssh.port"
                />
              </div>
            </div>
          </transition>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            mode="in-out"
          >
            <div
              class="col-sm-12 col-md-6"
              v-if="acc.haveSSH && !acc.hostSameAsAbove"
            >
              <div class="form-group">
                <label for="sshIP">SSH Username</label>
                <input
                  type="text"
                  :name="`sshUsername_${index}`"
                  class="form-control"
                  required
                  v-model.trim="acc.ssh.username"
                />
              </div>
            </div>
          </transition>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            mode="in-out"
          >
            <div
              class="col-sm-12 col-md-6"
              v-if="acc.haveSSH && !acc.hostSameAsAbove"
            >
              <div class="form-group">
                <label for="sshIP">SSH Password</label>
                <input
                  type="text"
                  :name="`sshPassword_${index}`"
                  class="form-control"
                  required
                  v-model.trim="acc.ssh.password"
                />
              </div>
            </div>
          </transition>
        </div>
        <!-- End of Repeative .row -->
        <div class="row">
          <div class="col">
            <button
              class="btn btn-round bg-peach mt-4"
              :disabled="checkDetailsFilled"
              @click.prevent="addAnotherMigrationSite"
            >
              <i class="fa fa-plus"></i> Add Another Site To Migrate
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p
              class="text-center text-danger mt-4"
              :class="`mc-${migrationCount}`"
              style="font-size: 1.2rem;"
            >
              <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
              <strong>IMPORTANT!</strong>
              Please ensure all login details have been double checked before
              proceeding! Non-working logins will cause migration delays. If
              enabled, please temporarily remove any two-factor authentication
              (2FA) as it will help ensure a quick migration
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="add-addon-domain-modal">
      <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        id="addAddonDomain"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add New Addon Domain</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row" v-if="showCost">
                <div class="col-12">
                  <div class="count-badges center mb-2">
              <span class="badge bg-violate big-badge mr-2">Migrations Used: {{ freeMigrationCountShow }} of
                {{ migrationFreeLimit }}</span>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <h5 class="text-danger">A $25 One Time Fee Will Apply!</h5>
                      <p>
                        Your plan ({{ selectedPlanFullName }}) currently supports {{ migrationFreeLimit }} free migration. Each extra migration will cost a <strong>$25 one time fee</strong>.  Please check out our <a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">Managed WP page</a> or <a href="https://www.bigscoots.com/contact/" target="_blank">contact us</a> for further details.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <p>
                <span class="badge badge-success mr-2 align-top"
                  >Selected Plan</span
                >
                <span class="align-middle">{{ selectedPlanFullName }}</span>
              </p>
              <div class="form-group">
                <label for="addonDomainName"
                  >Addon Domain Name
                  <strong class="text-danger">*</strong></label
                >
                <input
                  type="text"
                  name="addonDomainName"
                  id="addonDomainName"
                  class="form-control"
                  placeholder="Example: domain.com"
                  required
                  v-model.trim="addonDomain"
                  @input="addonDomainValid"
                  v-lowercase
                />
              </div>
              <div
                class="alert alert-danger"
                v-if="addonCount >= addonFreeLimit"
              >
                <p class="m-0">
                  <strong>Please Note!</strong> Your selected plan supports
                  {{ addonFreeLimit }} free addon domains which have all been
                  used. Each additional addon domain will cost
                  <strong>$9.95/month</strong>.
                </p>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                :disabled="addonDomain === ''"
                @click.prevent="addAddonDomainInit"
              >
                Add New Addon Domain
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <host-video-modal id="site-access-video" :host="selectedHost" />
  </div>
</template>

<script>
import { db } from "@/firebase/init";
import swal from "sweetalert2";
import { functions } from "@/firebase/init";
import { eventBus } from "@/main";
import assignDomainMixin from "../../../../mixins/assignDomainMixin";
import randomString from "randomstring";
import copyButtonMixin from "../../../../mixins/copyButtonMixin";
import hostVideoModal from "../../hostVideoModal";
import isValidDomain from "is-valid-domain";

export default {
  name: "MigrationSiteDetails",
  mixins: [assignDomainMixin, copyButtonMixin],
  components: {
    hostVideoModal,
  },
  data() {
    return {
      alreadyMigratedDomains: [],
      hostAccessRemainingDomains: [],
      selectedDomains: [],
      addAddonDomainIndex: null,
      showCost: false,
      updateCallCounter: 0,
      addonDomain: "",
      commonHosts: [
        "WPOPT",
        "OrangeGeek",
        "WP Engine",
        "FlyWheel",
        "BlueHost",
        "HostGator",
        "GoDaddy",
        "Kinsta",
        "SiteGround",
        "Other",
      ],
      migrationDomain: [
        {
          domain: this.domainToMigration,
          chargable: false,
          hostSameAsAbove: false,
          currentHost: {
            name: "",
            url: "",
            username: "",
            password: "",
          },
          wpAdminDetails: {
            username: "",
            password: "",
            loginURL: "",
          },
          haveSSH: false,
          ssh: {
            ip: "",
            port: "",
            username: "",
            password: "",
          },
          domainRegSameAsHost: false,
          domainRegistar: {
            name: "",
            url: "",
            username: "",
            password: "",
          },
          showAccessBtn: false,
          accessGranted: null,
          domainAccessGranted: null,
          domainShowAccessBtn: false,
        },
      ],
      denied: false,
      pendingAccounts: [],
    };
  },
  props: {
    collaboration: {
      type: Boolean,
      default() {
        return false;
      },
    },
    collaboratorUID: {
      type: String,
      default() {
        return "";
      },
    },
    supervisor: {
      type: Object,
      default() {
        return {};
      },
    },
    domainToMigration: {
      type: String,
      default() {
        return "";
      },
    },
  },

  computed: {
    checkMigrationDomainObj() {
      let flag=true;
      for (let i = 0; i < this.migrationDomain.length; i++) {
        if (!this.migrationDomain[i].hostSameAsAbove || i===0) {
          console.log('this.migrationDomain[i].hostSameAsAbove == false || i===0')
          if (
            !this.migrationDomain[i].domain ||
            !this.migrationDomain[i].currentHost.name ||
            !this.migrationDomain[i].currentHost.url ||
            !this.migrationDomain[i].currentHost.username ||
            !this.migrationDomain[i].currentHost.password ||
            !this.migrationDomain[i].wpAdminDetails.username ||
            !this.migrationDomain[i].wpAdminDetails.password ||
            !this.migrationDomain[i].wpAdminDetails.loginURL

          ) {

          console.log('this.migrationDomain[i].wpAdminDetails.loginURL || i===0')
           flag=false;
           break;
          }
        } else if(this.migrationDomain[i].hostSameAsAbove){
       console.log('else')
          if (
            !this.migrationDomain[i].domain ||
            !this.migrationDomain[i].wpAdminDetails.username ||
            !this.migrationDomain[i].wpAdminDetails.password ||
            !this.migrationDomain[i].wpAdminDetails.loginURL
          ) {
            flag=false;
            break;
          }
        }

      }
      return flag;
    },
    clientID() {
      return this.$store.getters["getRequestCustomerID"];
    },
    migrationPlanIndex() {
      return this.$store.getters["migration/planIndex"];
    },
    migrationCount() {
      return this.$store.getters["migration/count"];
    },
    addonCount() {
      return this.$store.getters["migration/addonCount"];
    },
    hostingAccounts() {
      return this.$store.getters["hosting/accounts"];
    },
    userToken() {
      return this.$store.getters.getUserToken;
    },
    domainList() {
      const accounts = this.hostingAccounts;
      if (accounts === undefined) {
        return [];
      }
      const selectedPlanAccount = [];
      accounts.forEach((acc, index) => {
        if (this.migrationPlanIndex === index) {
          selectedPlanAccount.push(acc.primary.domain);

          acc.addon.forEach((addonAcc) => {
            selectedPlanAccount.push(addonAcc.domain);
          });
        }
      });

      return selectedPlanAccount;
    },
    checkDetailsFilled() {
      let flag;
      if (this.migrationDomain.length > 0) {
        this.migrationDomain.forEach((acc, index) => {
          if (index === 0) {
            if (
              acc.domain === "" ||
              acc.currentHost.name === null ||
              acc.currentHost.name === "" ||
              acc.currentHost.url === null ||
              acc.currentHost.name === "" ||
              acc.currentHost.username === null ||
              acc.currentHost.username === "" ||
              acc.currentHost.password === null ||
              acc.currentHost.password === "" ||
              acc.wpAdminDetails.username === "" ||
              acc.wpAdminDetails.password === "" ||
              acc.wpAdminDetails.loginURL === ""
            ) {
              flag = true;
            } else {
              flag = false;
            }
          } else {
            if (acc.domain === "" && acc.hostSameAsAbove === true) {
              flag = true;
            } else if (acc.hostSameAsAbove === false) {
              if (
                acc.domain === "" ||
                acc.currentHost.name === null ||
                acc.currentHost.name === "" ||
                acc.currentHost.url === null ||
                acc.currentHost.name === "" ||
                acc.currentHost.username === null ||
                acc.currentHost.username === "" ||
                acc.currentHost.password === null ||
                acc.currentHost.password === ""
              ) {
                flag = true;
              } else {
                flag = false;
              }
            }
          }
        });
      }
      return flag;
    },
    videoAccessGrantedOrDenied() {
      return this.hostAccessRemainingDomains.length <= 0;
    },
    selectedPlanName() {
      if (typeof this.migrationPlanIndex === "number") {
        const plans = this.hostingAccounts;
        if (plans === undefined || plans.length <= 0) {
          return null;
        }
        const selectedPlanFullName = plans[this.migrationPlanIndex].planName;
        const temp = selectedPlanFullName.split(" ");
        const selectedPlanShortName = temp[1].toLowerCase().trim();
        return selectedPlanShortName;
      } else {
        return null;
      }
    },
    selectedPlanFullName() {
      if (typeof this.migrationPlanIndex === "number") {
        const plans = this.hostingAccounts;
        if (plans === undefined || plans.length <= 0) {
          return null;
        }
        const selectedPlanFullName = `${
          plans[this.migrationPlanIndex].planName
        } - ${plans[this.migrationPlanIndex].primary.domain}`;
        return selectedPlanFullName;
      } else {
        return null;
      }
    },
    migrationFreeLimit() {
      const allMigrationLimit = this.$store.getters["migration/limit"];
      if (
        this.migrationPlanIndex !== null && this.hostingAccounts.length > 0 &&
        this.hostingAccounts[this.migrationPlanIndex].maxMigrations
      ) {
        return this.hostingAccounts[this.migrationPlanIndex].maxMigrations;
      }
      // Loop through the received object to get the limit for our selected plan
      for (const key in allMigrationLimit) {
        if (this.selectedPlanName === key) {
          return allMigrationLimit[key];
        }
      }
    },
    addonFreeLimit() {
      return this.$store.getters["migration/addonLimit"];
    },
    freeMigrationCountShow() {
      return this.migrationCount <= this.migrationFreeLimit
        ? this.migrationCount
        : this.migrationFreeLimit;
    },
    freeAddonCountShow() {
      return this.addonCount <= this.addonFreeLimit
        ? this.addonCount
        : this.addonFreeLimit;
    },
    userUID() {
      return this.$store.getters.getUID;
    },
    user() {
      return this.$store.getters.user;
    },
    selectedHost() {
      return (this.addAddonDomainIndex !== null && this.migrationDomain[this.addAddonDomainIndex])
        ? this.migrationDomain[this.addAddonDomainIndex].currentHost.name
        : "";
    }
  },
  watch: {
    videoAccessGrantedOrDenied(value) {
      this.$store.commit("migration/mutateHostVideoAccessResponseFlag", value);
    },
    addonDomain(value) {
      this.addonDomain = value.toLowerCase();
    },
  },
  methods: {
    showDomainAlert () {
      const newArray = [...this.selectedDomains, ...this.alreadyMigratedDomains]
      const notUsed = this.domainList.filter((domain)=> {
        return !newArray.includes(domain)
      });
      return !notUsed.length
    },
    hostSameAsAbove(index) {
      this.migrationDomain[index].hostSameAsAbove = !this.migrationDomain[index]
        .hostSameAsAbove;
      if (this.hostAccessRemainingDomains.includes(index)) {
        this.hostAccessRemainingDomains.splice(
          this.hostAccessRemainingDomains.indexOf(index),
          1
        );
      }
      this.migrationDomain[index].showAccessBtn = false;
      this.migrationDomain[index].accessGranted = null;
      if (!this.migrationDomain[index].hostSameAsAbove) {
        this.denied = false;
        this.migrationDomain[index].currentHost.password = null;
        this.migrationDomain[index].currentHost.username = null;
        this.migrationDomain[index].currentHost.url = null;
        this.migrationDomain[index].currentHost.name = "";
      }
    },
    resetHostFields(index) {
      this.denied = false;
      this.migrationDomain[index].accessGranted = null;
      this.migrationDomain[index].currentHost.password = null;
      this.migrationDomain[index].currentHost.username = null;
      this.migrationDomain[index].currentHost.url = null;
      this.migrationDomain[index].currentHost.name = "";
      if (this.hostAccessRemainingDomains.includes(index)) {
        this.hostAccessRemainingDomains.splice(
          this.hostAccessRemainingDomains.indexOf(index),
          1
        );
      }
    },
    grantedAccess() {
      if (this.hostAccessRemainingDomains.includes(this.addAddonDomainIndex)) {
        this.hostAccessRemainingDomains.splice(
          this.hostAccessRemainingDomains.indexOf(this.addAddonDomainIndex),
          1
        );
      }
      this.denied = false;
      this.migrationDomain[this.addAddonDomainIndex].accessGranted = true;
      this.migrationDomain[this.addAddonDomainIndex].showAccessBtn = false;
      this.migrationDomain[this.addAddonDomainIndex].currentHost.password =
        "Access granted";
      this.migrationDomain[this.addAddonDomainIndex].currentHost.username =
        "Access granted";
      this.migrationDomain[this.addAddonDomainIndex].currentHost.url =
        "Access granted";
    },
    deniedAccess() {
      if (this.hostAccessRemainingDomains.includes(this.addAddonDomainIndex)) {
        this.hostAccessRemainingDomains.splice(
          this.hostAccessRemainingDomains.indexOf(this.addAddonDomainIndex),
          1
        );
      }
      this.denied = true;
      this.migrationDomain[this.addAddonDomainIndex].showAccessBtn = false;
      this.migrationDomain[this.addAddonDomainIndex].accessGranted = false;
      this.migrationDomain[
        this.addAddonDomainIndex
      ].currentHost.password = null;
      this.migrationDomain[
        this.addAddonDomainIndex
      ].currentHost.username = null;
      this.migrationDomain[this.addAddonDomainIndex].currentHost.url = null;
    },
    changedHost(value, index) {
      this.denied = false;
      this.migrationDomain[index].accessGranted = null;
      this.migrationDomain[index].currentHost.password = null;
      this.migrationDomain[index].currentHost.username = null;
      this.migrationDomain[index].currentHost.url = null;
      if (value === "GoDaddy" || value === "SiteGround") {
        this.migrationDomain[index].showAccessBtn = true;
        if (!this.hostAccessRemainingDomains.includes(index)) {
          this.hostAccessRemainingDomains.push(index);
        }
      } else {
        this.migrationDomain[index].showAccessBtn = false;
        if (this.hostAccessRemainingDomains.includes(index)) {
          this.hostAccessRemainingDomains.splice(
            this.hostAccessRemainingDomains.indexOf(index),
            1
          );
        }
      }
    },
    addonDomainValid() {
      /* eslint-disable */
      $("#addonDomainName").valid();
      /* eslint-enable */
    },
    async addAnotherMigrationSite() {
      this.showCost = false;
      // Check if the user still have more free migration left
      let mCount = this.migrationCount + 1;

      if (mCount <= this.migrationFreeLimit) {
        if (this.showDomainAlert()) {
          $('#addAddonDomain').modal('show');
          $('.modal-backdrop').removeClass("modal-backdrop");
          this.fixModal(this.migrationDomain.length)
        } else {
          const result = await swal({
            title: "Are you sure?",
            text:
              "Please confirm you would like to add another site to be migrated",
            type: "question",
            confirmButtonText: "Yes Proceed",
            confirmButtonColor: "#6ACF98",
            showCancelButton: true,
            cancelButtonText: "No Thanks",
            cancelButtonColor: "#EE8057",
          });
          if (!result.value) {
            return
          }
        }
        // Increase the migration counter by 1
        this.$store.dispatch("migration/countUpdate", { count: mCount });

        console.log('before')
        // Now add new migration section
        this.migrationDomain.push({
          domain: "",
          chargable: false,
          hostSameAsAbove: true,
          currentHost: {
            name: "",
            url: "",
            username: "",
            password: "",
          },
          wpAdminDetails: {
            username: "",
            password: "",
            loginURL: "",
          },
          haveSSH: false,
          ssh: {
            ip: "",
            port: "",
            username: "",
            password: "",
          },
          domainRegSameAsHost: false,
          domainRegistar: {
            name: "",
            url: "",
            username: "",
            password: "",
          },
          showAccessBtn: false,
          accessGranted: null,
          domainAccessGranted: null,
        });
      } else {
        this.showCost = true
        if (this.showDomainAlert()) {
          $('#addAddonDomain').modal('show');
          $('.modal-backdrop').removeClass("modal-backdrop");
          this.fixModal(this.migrationDomain.length)
        } else {
          const result = await swal({
            title: "A $25 One Time Fee Will Apply!",
            html: `Your plan (${this.selectedPlanFullName}) currently supports ${this.migrationFreeLimit} free migration. Each extra migration will cost a <strong>$25 one time fee</strong>.  Please check out our <a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">Managed WP page</a> or <a href="https://www.bigscoots.com/contact/" target="_blank">contact us</a> for further details.`,
            type: "warning",
            confirmButtonText: "Yes Proceed",
            confirmButtonColor: "#6ACF98",
            showCancelButton: true,
            cancelButtonText: "No Thanks",
            cancelButtonColor: "#EE8057",
          });

          if (!result.value) {
            return
          }
        }
        // Increase the migration counter by 1
        this.$store.dispatch("migration/countUpdate", { count: mCount });

        // Now add new migration section
        this.migrationDomain.push({
          domain: "",
          chargable: true,
          hostSameAsAbove: true,
          currentHost: {
            name: "",
            url: "",
            username: "",
            password: "",
          },
          wpAdminDetails: {
            username: "",
            password: "",
            loginURL: "",
          },
          haveSSH: false,
          ssh: {
            ip: "",
            port: "",
            username: "",
            password: "",
          },
          domainRegSameAsHost: false,
          domainRegistar: {
            name: "",
            url: "",
            username: "",
            password: "",
          },
          showAccessBtn: false,
          accessGranted: null,
          domainAccessGranted: null,
        });
      }
    },
    fixModal(index) {
      this.addAddonDomainIndex = index;
      /* eslint-disable */
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".add-addon-domain-modal");
        $(".modal-backdrop").removeClass("modal-backdrop");
      });
      /* eslint-enable */
    },
    deleteAccountItem(index) {
      swal({
        title: "Sure about deleting?",
        text: "Please confirm you no longer want to migrate this site",
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057",
      }).then((result) => {
        if (result.value === true) {
          if (this.migrationDomain[index].domain && this.selectedDomains.includes(this.migrationDomain[index].domain)) {
            this.selectedDomains.splice(this.selectedDomains.indexOf(this.migrationDomain[index].domain))
          }
          this.migrationDomain.splice(index, 1);
          this.$store.dispatch("migration/countUpdate", {
            count: this.migrationCount - 1,
          });
        }
      });
    },
    addAddonDomainInit() {
      // Check if the user has actually added any addon domain or not.
      if (this.addonDomain === null || this.addonDomain === "") {
        swal({
          title: "Enter the addon domain name",
          text:
            "Make sure you have entered the addon domain name before proceeding.",
          type: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#6ACF98",
        });
      } else {
        let isFullDomainName = isValidDomain(this.addonDomain, {
          subdomain: true,
          wildcard: false,
        });
        console.log(this.addonDomain);
        console.log(isFullDomainName);
        if (!isFullDomainName || this.addonDomain.includes("www.")) {
          console.log("invalid domain");
          swal(
            "Invalid Domian!",
            "Domain should not have https://, http:// or www",
            "error"
          );
          return;
        }
        // if(this.addonDomain.includes('http') || this.addonDomain.includes('https')){
        // 	try{
        // 		const domainUrl = new URL(this.addonDomain);
        // 		this.addonDomain = domainUrl.hostname;
        // 	}catch (e) {
        // 		console.log('Invalid URL....');
        // 	}
        // }
        // this.addonDomain = this.addonDomain.replace('www.', '').toLowerCase();
        // if(this.addonDomain.split('.').length < 2){
        // 	swal('Error!', 'Domain\'s tld name is missing.', 'error');
        // 	return;
        // }
        if (!this.checkDuplication(this.addonDomain)) {
          swal("Error!", "This Domain is already exist.", "error");
          return;
        }

        console.log(this.addonDomain);
        const plans = JSON.parse(
          JSON.stringify(this.$store.getters["hosting/accounts"])
        );

        const addonDomainStructure = JSON.parse(
          JSON.stringify(this.$store.getters["hosting/addonDomainStructure"])
        );

        if (plans[this.migrationPlanIndex].primary.domain === "") {
          console.log("Creating new primary domain...");
          plans[this.migrationPlanIndex].primary.domain = this.addonDomain;
          plans[this.migrationPlanIndex].primary.freashInstall = false;
          plans[this.migrationPlanIndex].primary.ftp.host =
            plans[this.migrationPlanIndex].primary.serverIP;
          plans[this.migrationPlanIndex].primary.cloudflare.username =
            plans[this.migrationPlanIndex].primary.hbServiceID +
            "@bigscoots-wpo.com";
          plans[
            this.migrationPlanIndex
          ].primary.cloudflare.password = randomString.generate(35); // '5O07zb0jRSxN98KMLhirOZfTQCgW0wf3!';
          this.addAddonDomainDB(
            plans,
            false,
            plans[this.migrationPlanIndex].primary,
            true
          );
        } else {
          let chargable;
          // Check if the addon addition is free or paid
          if (this.addonCount < this.addonFreeLimit) {
            addonDomainStructure.domain = this.addonDomain;
            addonDomainStructure.status = "pending";
            chargable = false;
          } else {
            addonDomainStructure.domain = this.addonDomain;
            addonDomainStructure.chargable = true;
            addonDomainStructure.status = "pending";
            chargable = true;
          }
          addonDomainStructure.freashInstall = false;

          const primary = plans[this.migrationPlanIndex].primary;
          if (primary.cloudflare.username && primary.cloudflare.password) {
            addonDomainStructure.cloudflare.username =
              primary.cloudflare.username;
            addonDomainStructure.cloudflare.password =
              primary.cloudflare.password;
            console.log("CF details added in ad-on domain structure.");
          }
          addonDomainStructure.tags = [{title: 'Pending Migration', type: 'badge-warning'}]

          plans[this.migrationPlanIndex].addon.push(addonDomainStructure);
          this.$store.dispatch("migration/addonCountUpdate", {
            count: this.addonCount + 1,
          });

          this.addAddonDomainDB(plans, chargable, addonDomainStructure, false);
        }
        this.migrationDomain[
          this.addAddonDomainIndex
        ].domain = this.addonDomain;
        this.fillWPAdminLoginUrl(this.addAddonDomainIndex);
        this.addAddonDomainIndex = null;
      }
    },
    addAddonDomainDB: async function(plans, chargable, addonDomainStructure, isPrimary) {
      // Set asyncDone to false
      this.$store.dispatch("async/stateUpdate", { state: false });
      try{
        let result=await this.$http.post('domain/queue', {
          grant_type: "token",
          clientID: this.clientID,
          customerUID: this.collaboration ? this.collaboratorUID : this.userUID,
          planIndex: this.migrationPlanIndex,
          addonDomainStructure: addonDomainStructure,
          domainType: 'Add-on',
          planFullName: this.selectedPlanFullName,
          addonDomain: this.addonDomain,
          chargable: chargable,
          freashInstall: false,
          registrar: "null",
          cloneInstall: false,
          migrateInstall: true,
          cc: this.collaboration ? this.user.email : "",
          submitterName: this.user.firstName + " " + this.user.lastName,
          // queue data
          ip: plans[this.migrationPlanIndex].primary.ftp.host,
          domain: this.addonDomain,
          token: this.userToken,
          firstName: this.collaboration
          ? this.supervisor.supervisorName
          : this.user.firstName,
          lastName: this.collaboration
          ? this.supervisor.supervisorName
          : this.user.lastName,
          existingAdOnIndex: plans[this.migrationPlanIndex].addon.length - 1, //passing the index of newly added adon domain object...
          type: "migrate",
          isPrimary,
          collaborator: this.collaboration ? "1" : "0",
          collaboratorUID: this.user.uid,
          email:(this.isCollaboration) ? this.supervisor.email : this.user.email,
          fresh: "false",
        })
            // Pass the updated plan to Vuex
            if (!this.collaboration) {
              this.$store.dispatch("hosting/loadAccounts", { accounts: plans });
            } else {
              await this.assignDomain(
                this.addonDomain,
                this.collaboratorUID,
                this.userUID,
                this.supervisor
              );
              // await this.$store.dispatch("hosting/fetchAccounts", {UID: this.collaboratorUID, allowedDomains: this.supervisor.allowedDomains})
            }

            // Set asyncDons to true
            await this.$store.dispatch("async/stateUpdate", { state: true });

            swal({
              title: "Addon domain added successfully",
              text: result.data.data.message,
              type: "success",
              confirmButtonText: "OK",
              confirmButtonColor: "#6ACF98",
            });

      }
      catch(err){
       // Clear addon domain field
          this.addonDomain = "";

          // Set asyncDons to true
          this.$store.dispatch("async/stateUpdate", { state: true });

          this.addLog({
            message:
              "Error: Error add New Addon Domain. Message:" + err.message,
            level: "danger",
          });
      }

    },
     getAlreadyMigratedDomains(){
      const uid = this.collaboration ? this.collaboratorUID : this.userUID;
       db
        .collection("savedMigrations")
        .where("uid", "==", uid)
        .where("status", "in", ['pending', 'review'])
        .get().then(res => {
          res.docs.forEach(doc => this.alreadyMigratedDomains.push(doc.data().siteDetails.domainName))
        })
    //

    },
    async checkDomainMigration(index) {

      this.$store.dispatch("async/stateUpdate", { state: false });
      const uid = this.collaboration ? this.collaboratorUID : this.userUID;
      const snapshotPending = await db
        .collection("savedMigrations")
        .where("uid", "==", uid)
        .where("status", "==", "pending")
        .get();
      const snapshotReview = await db
        .collection("savedMigrations")
        .where("uid", "==", uid)
        .where("status", "==", "review")
        .get();
      const docsPpending = snapshotPending.docs;
      const docsReview = snapshotReview.docs;
      const docs = docsPpending.concat(docsReview);

      // console.log('%cSiteDetails.vue line:1304 docs.length', 'color: #007acc;', docs.length);
      for (let doc of docs) {
        const data = doc.data();
        console.log('daata',data);
        if (
          data.siteDetails.domainName === this.migrationDomain[index].domain
        ) {
          this.$store.dispatch("async/stateUpdate", { state: true });
          this.migrationDomain[index].domain = null;
          return swal({
            title: "Error",
            text: "You have already submitted Migration for this domain.",
            type: "error",
          });
        }
      }
      this.$store.dispatch("async/stateUpdate", { state: true });
    },
    async fillWPAdminLoginUrl(index) {
      await this.checkDomainMigration(index);
      if (this.migrationDomain[index].domain) {
        this.selectedDomains[index] = this.migrationDomain[index].domain;
        this.migrationDomain[index].wpAdminDetails.loginURL =
          "https://" + this.migrationDomain[index].domain + "/wp-admin";
        this.$store.commit("migration/mutateAlternateEmail", "");
      } else {
        this.selectedDomains.splice(index, 1);
        this.migrationDomain[index].wpAdminDetails.loginURL = "";
      }
    },
  },
   mounted() {
    if (this.domainToMigration !== "") {
      this.fillWPAdminLoginUrl(0);
    }
 this.getAlreadyMigratedDomains();
 console.log('%cSiteDetails.vue line:1361 this.alread', 'color: #007acc;', this.alreadyMigratedDomains);

  },
  created() {
    eventBus.$on("nextPage", (data) => {
      // Only execute if the page is going from site details to domain details
      if (data.page === "site details") {
        const accounts = this.hostingAccounts;
        if (accounts === undefined) {
          return [];
        }
        this.pendingAccounts = [];
        accounts.forEach((acc, index) => {
          if (this.migrationPlanIndex === index) {
            acc.addon.forEach((addonAcc) => {
              if (
                addonAcc.status === "pending" &&
                !this.migrationDomain.find((o) => o.domain === addonAcc.domain)
              ) {
                this.pendingAccounts.push(addonAcc.domain);
              }
            });
          }
        });
        if (this.checkMigrationDomainObj) {
          if (this.pendingAccounts.length > 0) {
        console.log('%cSiteDetails.', this.pendingAccounts, this.alreadyMigratedDomains);
        console.log('%.', this.pendingAccounts, this.pendingAccounts.length);
        // this.pendingAccounts.forEach((el, index) => {
        //   this.alreadyMigratedDomains.forEach(el1 => {
        //     if(el1==el){

        //       console.log('%cSiteDetails.vue line:1378 el', 'color: #007acc;', el);
        //     }
        //   })
        // })
        const newArray = this.pendingAccounts.filter((o)=> !this.alreadyMigratedDomains.includes(o))

            if (newArray.length > 0) {
              swal({
                title: "Are you sure?",
                text: `Are you sure you want to proceed, without adding ${newArray} domains to migrate?`,
                type: "question",
                confirmButtonText: "Yes Proceed",
                confirmButtonColor: "#6ACF98",
                showCancelButton: true,
                cancelButtonText: "No",
                cancelButtonColor: "#EE8057",
                buttons: {
                  cancel: {
                    value: false,
                    visible: true,
                    // className: "btn-previous",
                    closeModal: true,
                  },
                },
              }).then((resp) => {
                if (resp.value == undefined || resp.dismiss == "cancel") {
                  console.log(
                      "%cSiteDetails.vue line:985 resp",
                      "color: #007acc;",
                      resp.value == undefined,
                      resp.dismiss
                  );
                  this.$emit("onCancel", { value: true });
                } else {
                  this.$emit("onCancel", { value: false });
                }
              });
            }
          }
        }

        if (this.migrationPlanIndex !== "") {
          this.$store.dispatch("migration/migrationListUpdate", {
            list: this.migrationDomain,
          });
        }
      }
    });


  },

  updated() {
    /* eslint-disable */
    $(document).ready(function() {
      $('[data-toggle="tooltip"]').tooltip();

      $('[name*="migrationDomainName"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="wp-username"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });
      $('[name*="wp-password"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });
      $('[name*="wp-admin-url"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="currentHost"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="currentHostURL"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="currentHostUsername"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="currentHostPassword"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="sshIP"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="sshPort"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="sshUsername"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });

      $('[name*="sshPassword"]').each(function() {
        $(this).rules("add", {
          required: true,
        });
      });
    });
    /* eslint-enable */

    this.updateCallCounter++;
    if (this.updateCallCounter <= 3) {
      // check if user's existing migration counter which is already increased by 1 is more than the free limit
      if (this.migrationCount > this.migrationFreeLimit) {
        swal({
          title: "A $25 One Time Fee Will Apply!",
          html: `Your plan (${this.selectedPlanFullName}) currently supports ${this.migrationFreeLimit} free migration. Each extra migration will cost a <strong>$25 one time fee</strong>.  Please check out our <a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">Managed WP page</a> or <a href="https://www.bigscoots.com/contact/" target="_blank">contact us</a> for further details.`,
          type: "warning",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057",
        }).then((result) => {
          if (result.dismiss === "cancel") {
            if (this.collaboration) {
              console.log("Idher");
              this.$parent.$parent.changeSection("sites");
            } else {
              this.$router.push({ name: "migrationLog" });
            }
          } else if (result.value === true) {
            this.migrationDomain[0].chargable = true;
          }
        });
      }
    }
  },
};
</script>

<style scoped>
.domain_selection option:disabled {
  background: red;
  color: #fff;
}
</style>
